// src/api/kpas.js
import api from './axios';

/** List KPAs for a contract */
export async function listKpas(contractId) {
    const { data } = await api.get('/api/kpas', {
        params: { contract_id: contractId, per_page: 1000 },
    });
    return data?.data ?? [];
}

/** Create KPA
 * payload: { name, contract_id, weight, timeframe_id?, alignment, parent_id?, order? }
 */
export async function createKpa(payload) {
    const { data } = await api.post('/api/kpas', payload);
    return data;
}

/** Update KPA
 * id: number
 * patch: { name?, weight?, timeframe_id?, alignment?, parent_id?, order? }
 */
export async function updateKpa(id, patch) {
    const { data } = await api.patch(`/api/kpas/${id}`, patch);
    return data;
}

/** Delete KPA */
export async function deleteKpa(id) {
    await api.delete(`/api/kpas/${id}`);
    return true;
}

/** Reorder KPAs within a contract
 * items: [{ id, order }, ...]
 */
export async function reorderKpas(contractId, items) {
    const { data } = await api.post(`/api/contracts/${contractId}/kpas/reorder`, { items });
    return data;
}

export async function fetchManagerKpasV1(contractId) {
    const { data } = await api.get(`/api/contracts/${contractId}/manager-kpas`);
    return data; // { manager_contract_id, items: [...] }
}

export async function cascadeManagerKpasV1(contractId, payload) {
    // payload: { mode: 'all' | 'selected', kpa_ids?: number[], overrides?: [{id, weight?, name?, timeframe_id?, alignment?, description?}] }
    const { data } = await api.post(`/api/contracts/${contractId}/kpas/cascade`, payload);
    return data;
}

/** Contract-scoped: list manager KPAs (and manager info if backend returns it) */
export async function fetchManagerKpas(contractId) {
    const { data } = await api.get(`/api/contracts/${contractId}/manager-kpas`);

    const manager = data?.manager ?? null;
    const rows = Array.isArray(data?.data) ? data.data : [];
    return { manager, kpas: rows };
}
/** Contract-scoped: cascade selected manager KPAs into this contract */
/** Contract-scoped: cascade selected/all manager KPAs into this contract */
export async function cascadeManagerKpas(contractId, { kpa_ids, mode = 'selected', overrides } = {}) {
    // backend expects: { mode: 'all'|'selected', kpa_ids?: number[], overrides?: [...] }
    return api.post(`/api/contracts/${contractId}/kpas/cascade`, {
        mode,
        kpa_ids,
        ...(overrides ? { overrides } : {}),
    });
}